var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"title":_vm.title || _vm.defaultTitle},domProps:{"textContent":_vm._s(_vm.abbreviatedValue)}})}
var staticRenderFns = []

export { render, staticRenderFns }